import { isWeb } from "@helpers/platform";
import { useAppTheme } from "@hooks/useAppTheme";
import { useDevice } from "@hooks/useDevice";
import Box from "@memorang/ui/src/components/Box";
import CustomChip from "@memorang/ui/src/components/CustomChip";
import type { IconType } from "@memorang/ui/src/types";
/* -----------------Child components--------------- */
import CustomListSubheaderContainer from "components/CustomListSubheaderContainer";
export const SectionHeader = ({
	sectionTitle,
	chipProps,
	handleClickChips,
}: {
	sectionTitle: string;
	chipProps?: {
		label: string;
		icon: IconType;
		background?: string;
	};
	handleClickChips?: () => void;
}) => {
	const { isMobile } = useDevice();

	const theme = useAppTheme();

	return (
		<Box
			justifyContent="space-between"
			alignItems="center"
			flexDirection="row"
			paddingVertical={8}
			paddingRight={isWeb && !isMobile ? 0 : 16}
		>
			<CustomListSubheaderContainer enableGutters={isMobile}>
				{sectionTitle}
			</CustomListSubheaderContainer>
			{chipProps && (
				<CustomChip
					onPress={handleClickChips}
					icon={chipProps.icon}
					iconColor={theme.colors.text}
					style={{
						backgroundColor: chipProps.background,
					}}
				>
					{chipProps.label}
				</CustomChip>
			)}
		</Box>
	);
};
